import { useContext } from 'react';

import type { IntegrationsBlocksSet, SpaceIntegrationBlocks } from '@gitbook/api-client';

import { ContentEditorContext } from '../contexts';

/**
 * Get all integrations that have blocks.
 */
export function useSpaceIntegrationsWithBlocks() {
    const { integrationData } = useContext(ContentEditorContext);
    return integrationData?.integrationsWithBlocks ?? null;
}

/**
 * Get all integration blocks installed and available on the current space
 */
export function useSpaceIntegrationsBlocks() {
    const { integrationData } = useContext(ContentEditorContext);
    return getIntegrationBlocksSetFromSpaceIntegrationBlocks(
        integrationData?.integrationBlocks ?? null
    );
}

/**
 * Transform a list of space integration blocks into a set of integration blocks.
 */
function getIntegrationBlocksSetFromSpaceIntegrationBlocks(
    integrationsBlocks: SpaceIntegrationBlocks | null
) {
    if (!integrationsBlocks) {
        return {} as IntegrationsBlocksSet;
    }
    const integrationsBlocksSet: IntegrationsBlocksSet = {};
    integrationsBlocks.forEach((integration) => {
        integrationsBlocksSet[integration.name] = integration.blocks;
    });

    return integrationsBlocksSet;
}
